import React from "react";

const PasswordRequirements = props => {
	return (
		<div className="password-requirements">
			{props.showAdequateLength && (
				<span className={`password-requirement ${props.adequateLength ? "met" : ""}`}>
					At least {props.minLength} characters
				</span>
			)}
			{props.showPasswordsMatch && props.adequateLength && (
				<span
					className={`password-requirement ${props.passwordsMatch ? "met" : ""} ${
						props.password.length === props.confirmedPassword.length && !props.passwordsMatch ? "warning-text" : ""
					}`}
				>
					{`${props.passwordsMatch ? "Passwords match" : "Passwords must match"}`}
				</span>
			)}
		</div>
	);
};

export default PasswordRequirements;
